import { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import InCountry from "../../Components/InCountry/InCountry";
import s from "./PreDeparturePAS.module.scss";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import CountriesBlueButtons from "../../Components/CountriesBlueButtons/CountriesBlueButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { getPreDepartureDiseaseDetails } from "../../redux/InformationSlice";
import { useParams } from "react-router-dom";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { useTranslation } from "react-i18next";
import { Seo } from "../../Seo";

interface Props {
  navigation: {
    name: string;
    path: string;
  };
}

const PreDeparturePAS = () => {
  const dispatch: AppDispatch = useDispatch();
  const disease = useSelector(
    (state: RootState) => state.info.preDepartureDiseaseDetails,
  );
  const params = useParams();
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getPreDepartureDiseaseDetails(Number(params.id)));
  }, [params]);

  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <Seo
        title="Запрещенные наркотические вещества в России"
        description="Информация для мигрантов на метадоновой терапии. Почему в России запрещен метадон, как пройти медосмотр и где получить помощь некоммерческих организаций."
        url="https://www.vputi.org/russia/pre-departure/pas/4"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}

        <InCountry />
        <Navigation
          navigation={{
            name: "Главная / Законодательство России / Для мигрантов, употребляющих психоактивные вещества",
            path: "/russia",
          }}
        />

        <ContactButtons />
        <div className={s.inner}>
          <div className={s.text}>
            <div className={s.text_title}>{disease?.title_1}</div>
            <div
              className={s.body}
              dangerouslySetInnerHTML={{ __html: disease?.body_1 ?? "" }}
            ></div>
          </div>
          {
            <div className={s.body_wrapper_2}>
              <div
                className={s.body2}
                dangerouslySetInnerHTML={{ __html: disease?.body_2 ?? "" }}
              ></div>
            </div>
          }
          {
            <div className={s.body_wrapper_3}>
              <div
                className={s.body3}
                dangerouslySetInnerHTML={{ __html: disease?.body_3 ?? "" }}
              ></div>
            </div>
          }

          <div className={s.title}>
            {t("Где я могу пройти обследования на родине?")}
          </div>

          <CountriesBlueButtons />
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default PreDeparturePAS;
